
var _fn, handle, CFG;
CFG = {
  TIMEOUT: 200000 // 超时时间
}
handle = {
  /**
   * 新ajax请求方法,之前的ajax方法废弃(不推荐使用)
   * @param url url
   * @param requestParam 请求参数
   * @param successFunc 成功回调函数
   * @param errorFunc 失败回调函数
   */
  fetch: function (url, requestParam, successFunc, errorFunc) {
    requestParam = requestParam || {};
    requestParam = _fn.urlEncode(requestParam);
    $.ajax({
      url: url,
      dataType: 'json',
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      data: requestParam,
      xhrFields: {
        withCredentials: true
      },
      type: 'POST',
      cache: false,
      timeout: CFG.TIMEOUT,
      success: function (res) {
        if (typeof successFunc == 'function') {
          _fn.callbackProxy(res);
          successFunc(res)
        }
      },
      error: function () {
        let data = {
          code: '-1',
          result: '加载数据失败',
          data: {}
        };
        if (typeof errorFunc == 'function') {
          _fn.callbackProxy(data);
          errorFunc(data)
        }
      }
    });
  },
  /**
   * 下载文件
   * @param url 文件地址
   * @return {Promise<Blob>}
   */
  fetchDownloadFile: function (url, fileName) {
    return fetch(url, {
        credentials: 'include'
      })
      .then(res => res.blob().then(blob => {
        let a = document.createElement('a');
        let url = window.URL.createObjectURL(blob); // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
        let disposition = res.headers.get('Content-Disposition');
        let filename = "";
        if (disposition && disposition.match(/attachment/)) {
          filename = disposition.replace(/.*filename=/, '').replace(/"/g, '');

        }

        a.href = url;
        filename = (filename && filename !== '') ? decodeURI(filename) : fileName;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }));

  },
  /**
   * 导出excel
   *  */
  postExcelFile(fileName, url, requestParam, successFunc, errorFunc) {
    fileName = fileName || '导出数据.xlsx'
    let defaultSuccessFunc = (data) => {
      // console.log("默认成功回调函数,data:" + JSON.stringify(data));
    };
    let defaultErrorFunc = (data) => {
      // console.log("默认失败回调函数,data:" + JSON.stringify(data));
    };

    successFunc = successFunc || defaultSuccessFunc;
    errorFunc = errorFunc || defaultErrorFunc;

    let body = _fn.urlEncode(requestParam);
    if (body.length > 0 && "&" === body.substring(0, 1)) {
      body = body.substr(1);
    }
    return fetch(url, {
      method: "post", // get/post
      mode: "cors", // same-origin/no-cors/cors
      cache: "no-cache", // 不缓存
      credentials: 'include', //傳送cookie
      responseType: "blob",
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Accept": "application/json; charset=UTF-8",
      },
      body: body,
    }).then(res => {
      if (res.status === 200) {
        res.blob().then(item => {
          let blob = item
          let reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = (e) => {
            let a = document.createElement('a')
            a.download = `${fileName}`
            a.href = e.target.result
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        }).then(function (data) {
          return successFunc(data);
        })
      } else {
        successFunc(res);
      }
    }).catch(function (error) {
      errorFunc(error);
    });
  },
  /**
   * 新ajax请求方法,之前的ajax方法废弃(不推荐使用),字节流提交表单
   * @param url url
   * @param requestParam 请求参数
   * @param successFunc 成功回调函数
   * @param errorFunc 失败回调函数
   */
  fetchMultipart: function (url, requestParam, successFunc, errorFunc) {

    let defaultSuccessFunc = (data) => {
      // console.log("默认成功回调函数,data:" + JSON.stringify(data));
    };
    let defaultErrorFunc = (data) => {
      // console.log("默认失败回调函数,data:" + JSON.stringify(data));
    };

    successFunc = successFunc || defaultSuccessFunc;
    errorFunc = errorFunc || defaultSuccessFunc;
    // 拼装post要提交的数据

    let body = _fn.objectToFormData(requestParam)

    return fetch(url, {
        method: "post", // get/post
        mode: "cors", // same-origin/no-cors/cors
        cache: "no-cache", // 不缓存
        credentials: 'include', //傳送cookie
        body: body,
      })
      .then(function (response) {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(function (data) {
        //权限统一拦截
        _fn.callbackProxy(data);
        return successFunc(data);
      })
      .catch(function (error) {
        errorFunc(error);
      });
  },
  //文件上传
  postFile: function() {
    let url,
      param,
      file,
      type,
      callback;
    if (arguments.length == 3) {
      url = arguments[0];
      type = 'json';
      param = arguments[1].param;
      file = arguments[1].file;
      callback = arguments[2];
    } else {
      return;
    }
    let formData = new FormData();
    formData.append("file", file);
    for (let i in param) {
      formData.append(i, param[i]);
    }

    $.ajax({
      url: url,
      type: "POST",
      data: formData,
      xhrFields: {
        withCredentials: true
      },
      /**
       *必须false才会自动加上正确的Content-Type
        */
      contentType: false,
      /**
       * 必须false才会避开jQuery对 formdata 的默认处理
       * XMLHttpRequest会对 formdata 进行正确的处理
       */
      processData: false,
      success: function (res) {
        if (typeof callback == 'function') {
          _fn.callbackProxy(res, callback(res));
        }
      },
      error: function (res) {
        if (typeof callback == 'function') {
          _fn.callbackProxy(res, callback(res));
        }
      }
    });
  }
};
_fn = {
  //解决options
  objectToFormData: function (obj, form, namespace) {
    const fd = form || new FormData();

    for (let property in obj) {
      if (obj.hasOwnProperty(property)) {
        let tempItem = obj[property];

        if (Array.isArray(tempItem)) {
          //for循环
          for (let index in tempItem) {
            let formKey;
            let key = "[" + index + "]";
            if (namespace) {
              formKey = namespace + key;
            } else {
              formKey = property + key;
            }

            let indexItem = tempItem[index];

            // if the property is an object, but not a File, use recursivity.
            if (typeof indexItem === 'object' && !(indexItem instanceof File)) {
              _fn.objectToFormData(indexItem, fd, formKey);
            } else {

              // if it's a string or a File object
              fd.append(formKey, indexItem);
            }

          }

        } else {
          //对象

          let key = "." + property;
          let formKey;
          if (namespace) {
            formKey = namespace + key;
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File, use recursivity.
          if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
            _fn.objectToFormData(tempItem, fd, formKey);
          } else {

            // if it's a string or a File object
            fd.append(formKey, tempItem);
          }
        }


      }
    }

    return fd;

  },
  urlEncode: function (param, key, encode) {
    if (param == null) return '';
    let paramStr = '';
    let t = typeof (param);
    if (t === 'string' || t === 'number' || t === 'boolean') {
      paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
    } else {
      for (let i in param) {
        let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
        paramStr += _fn.urlEncode(param[i], k, encode)
      }
    }
    return paramStr;

  },
  // 装饰参数
  decorateParam: function (param) {
    return param;
  },
  // 统一回调方案
  callbackProxy: function (data) {
    
    //权限统一拦截
    if (data.code === '9800') { //用户未登录
      var returnUrl = '';
      if (window.location.pathname == '/login') {
        return;
      }
      returnUrl = window.location.href;
      window.location.href = '/login?returnUrl=' + returnUrl
      return;
    }
    if (data.code === '9900') { //用户没有权限
      window.location.href = '/nopermissions'
      return;
    }
  },

}
export default handle